module.exports = __webpack_public_path__ + "img/image-schedule2024.5203b289.webp";